import { Spin } from "antd";
import { theme } from "styles/theme";

import { LoadingUserLayoutStyle } from "./LoadingUserLayout.style";

const LoadingUserLayout = () => {
  return (
    <LoadingUserLayoutStyle>
      <Spin
        spinning={true}
        size="large"
        style={{
          backgroundColor: theme.backgroundColors.primary,
          maxHeight: "100vh",
        }}
      >
        <div className="loading-bg"></div>
      </Spin>
    </LoadingUserLayoutStyle>
  );
};

export default LoadingUserLayout;
